import { useEffect, useRef } from 'react'

import { FeedbackType } from '../../domain/feedback'
import { Repository } from '../../repository/repository-utils'
import { useFlowBuilderSelector } from '../reducer/hooks'

export const useSave = (repository: Repository) => {
  const { state, resetChanges, updateAllNodes } = useFlowBuilderSelector(
    ctx => ctx
  )
  const stateRef = useRef(state)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  const saveFlow = async (): Promise<boolean> => {
    console.log('saving')
    if (!state.currentLocale) return false
    const savedStatus = await repository.cmsWriter.writeContent(
      stateRef.current
    )
    updateAllNodes(state.nodes, false)
    if (savedStatus === FeedbackType.SUCCESS) {
      resetChanges()
      return true
    }
    return false
  }

  return { saveFlow }
}
